import { useEffect } from "react";

import { playTickingAudio, stopTickingAudio } from "../audio";

import { useTimeRemaining } from "./use-time-remaining";

interface UseBreakoutEndingSoonObserverProps {
  breakoutSessionEndsAt: string | null | undefined;
  isInVirtualClass: boolean;
}

export const useBreakoutEndingSoonObserver = ({
  breakoutSessionEndsAt,
  isInVirtualClass,
}: UseBreakoutEndingSoonObserverProps) => {
  const breakoutEndDate = breakoutSessionEndsAt ? new Date(breakoutSessionEndsAt) : null;
  const { timeRemainingMs } = useTimeRemaining(breakoutEndDate);
  const TICKING_SOUND_STARTS_AT_MS = 12 * 1000;
  const timeToStartTickingHasPassed = !!(
    timeRemainingMs && timeRemainingMs < TICKING_SOUND_STARTS_AT_MS
  );

  useEffect(() => {
    if (!isInVirtualClass) return;
    if (timeToStartTickingHasPassed) {
      playTickingAudio();
    } else {
      stopTickingAudio();
    }
    // Take care to not enable sound unnecessarily.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeToStartTickingHasPassed]);

  // Stop ticking audio if leaving virtual class
  useEffect(() => {
    if (!isInVirtualClass) {
      stopTickingAudio();
    }
  }, [isInVirtualClass]);
};
